import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase';

/**
 * Subscribe to metrics_facility_current/{facilityId}. Returns the live doc data
 * (or null when missing / no facilityId), plus loading and error state.
 */
export function useFacilityCurrent(facilityId) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(Boolean(facilityId));
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!facilityId) {
            setLoading(false);
            setData(null);
            return undefined;
        }
        setLoading(true);
        setError(null);
        const ref = doc(db, 'metrics_facility_current', facilityId);
        const unsubscribe = onSnapshot(
            ref,
            (snap) => {
                setData(snap.exists() ? snap.data() : null);
                setLoading(false);
            },
            (err) => {
                setError(err);
                setLoading(false);
            },
        );
        return unsubscribe;
    }, [facilityId]);

    return { data, loading, error };
}
